import { render } from "./Compania.vue?vue&type=template&id=21a9245f&scoped=true"
import script from "./Compania.vue?vue&type=script&lang=js"
export * from "./Compania.vue?vue&type=script&lang=js"

import "../main.css?vue&type=style&index=0&lang=css&external"
import "./Compania.vue?vue&type=style&index=1&id=21a9245f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21a9245f"]])

export default __exports__